import lazysizes from "lazysizes";
import 'lazysizes/plugins/respimg/ls.respimg';

export default function() {
  document.addEventListener("lazybeforeunveil", function(e) {
    // For Loading Animations (on parent)
    let el = e.target;
    let parent = el.parentElement.parentElement;
    setTimeout(function() {
      parent.classList.add("-loaded");
    }, 200);

    // add simple support for background images:
    var bg = e.target.getAttribute("data-bg");
    if (bg) {
      e.target.style.backgroundImage = "url(" + bg + ")";
    }
  });
}
